import { create } from "zustand"
import { persist } from "zustand/middleware"

interface ChecklistState {
	isCollapsed: boolean
	toggleCollapsed: () => void
}

export const useChecklistState = create<ChecklistState>()(
	persist(
		(set) => ({
			isCollapsed: false,
			toggleCollapsed: () =>
				set((state) => ({ isCollapsed: !state.isCollapsed })),
		}),
		{
			name: "checklist-state",
		},
	),
)
